import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import { Box, Chip, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import {
  OPERATOR_CARD_SX,
  OPERATOR_HERO_HEADER_SX,
  OPERATOR_HERO_STATS_SX,
  OPERATOR_META_LABEL_SX,
  OPERATOR_META_VALUE_SX,
} from "./operatorReviewStyles";

const HeroMeta = ({ label, value }) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography sx={OPERATOR_META_LABEL_SX}>{label}</Typography>
    <Typography sx={OPERATOR_META_VALUE_SX}>{value || "—"}</Typography>
  </Box>
);

HeroMeta.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const OperatorReviewHero = ({
  values,
  workflowStageTitle,
  assignmentOwnerLabel,
  compact = false,
}) => {
  const fullName =
    [values.firstName, values.lastName].filter(Boolean).join(" ") ||
    values.fullName ||
    "—";
  const requestCode =
    values.referenceID ?? values.referenceId ?? values.id ?? "—";

  return (
    <Box sx={OPERATOR_CARD_SX}>
      <Box sx={OPERATOR_HERO_HEADER_SX}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          alignItems={{ xs: "flex-start", sm: "center" }}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              bgcolor: "background.paper",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              boxShadow: 1,
            }}
          >
            <AssignmentIndOutlinedIcon sx={{ fontSize: 32, color: "primary.main" }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Stack direction="row" flexWrap="wrap" gap={1} alignItems="center" sx={{ mb: 0.5 }}>
              <Typography variant="h6" fontWeight={800} sx={{ lineHeight: 1.35 }}>
                پرونده #{requestCode}
              </Typography>
              <Chip
                size="small"
                color="primary"
                label={workflowStageTitle || values.stepTitle || "بررسی اولیه"}
                sx={{ fontWeight: 700 }}
              />
              <Chip
                size="small"
                variant="outlined"
                label={values.requestConfirmTitle || "بررسی نشده"}
                sx={{ fontWeight: 600 }}
              />
              {values.leadPriorityTitle ? (
                <Chip
                  size="small"
                  color="warning"
                  variant="outlined"
                  label={`اولویت: ${values.leadPriorityTitle}`}
                />
              ) : null}
            </Stack>
            <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.4 }}>
              {fullName}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {[
                values.mobile ? `موبایل: ${values.mobile}` : null,
                assignmentOwnerLabel ? `مسئول: ${assignmentOwnerLabel}` : null,
              ]
                .filter(Boolean)
                .join(" | ")}
            </Typography>
          </Box>
        </Stack>
      </Box>

      {!compact ? (
        <Box sx={OPERATOR_HERO_STATS_SX}>
          <HeroMeta
            label="شناسه قبض"
            value={values.electricBoillNumber || values.ElectricBoillNumber}
          />
          <HeroMeta label="نوع نیروگاه" value={values.powerPlantTypeTitle} />
          <HeroMeta label="ظرفیت" value={values.plantCapacityTitle} />
          <HeroMeta label="نیاز به وام" value={values.needsLoan ? "بله" : "خیر"} />
          <HeroMeta label="مسئول پرونده" value={assignmentOwnerLabel} />
        </Box>
      ) : null}
    </Box>
  );
};

OperatorReviewHero.propTypes = {
  values: PropTypes.object.isRequired,
  workflowStageTitle: PropTypes.string,
  assignmentOwnerLabel: PropTypes.string,
  compact: PropTypes.bool,
};

export default OperatorReviewHero;
